import React from "react";
import I18n from "../../../i18n/";
import { CounselingGeneric } from "./index";
import ReportAction from "../../../actions/ReportAction";
import { CounselingSupportGraph } from "../../../constants/supportGraph";
import { TargetValueType } from "../CompareValuePanel";
import { OrgUtil } from "../../../util";
import { MockupWarning } from "../../../util/dev_layout";
import Config from "../../../config/index";

const Outcome = {
	NextWeek: "next_week",
	TwoWeek: "two_week",
	NextMonth:"next_month",
	No:"no",
	Hospital:"hospital",
	Psychiatrist:"psychiatrist",
};

const mockupMain = {
	total:{
		[Outcome.NextWeek]:10,
		[Outcome.TwoWeek]:20,
		[Outcome.NextMonth]:5,
		[Outcome.No]:8,
		[Outcome.Hospital]:8,
		[Outcome.Psychiatrist]:8,
	}
};

export default props => (
	<CounselingGeneric
		typeKey={CounselingSupportGraph.VisitOutcome}
		subHeader={I18n.t("visit_outcome")}
		fetchMain={ReportAction.fetchCounVisitOutcome}
	/>
);


// WEBPACK FOOTER //
// ./src/containers/ReportPanels/Counseling/CounselingVisitOutcome.js